import { render, staticRenderFns } from "./PatientMortalityReport.vue?vue&type=template&id=4151344c&scoped=true"
import script from "./PatientMortalityReport.vue?vue&type=script&lang=js"
export * from "./PatientMortalityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4151344c",
  null
  
)

export default component.exports